import { render, staticRenderFns } from "./OrdenCompraCargoTableComponent.vue?vue&type=template&id=fb23ffaa&"
import script from "./OrdenCompraCargoTableComponent.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraCargoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports